import { convertToTimeZone } from '../../../../utils/datetime.utils';
import { StyledTCellBody, StyledTRowBody } from '../styledComponents';
import React from 'react';

export default function BoxReportTRow({ rowData }) {
  if (!rowData) return;

  return (
    <StyledTRowBody>
      <StyledTCellBody> {rowData.store} </StyledTCellBody>
      <StyledTCellBody> {rowData.box} </StyledTCellBody>
      <StyledTCellBody>{rowData.total_bins}</StyledTCellBody>
      <StyledTCellBody>{rowData.available_bins}</StyledTCellBody>
      <StyledTCellBody>{rowData.pharmacy_used_bins}</StyledTCellBody>
      <StyledTCellBody>{rowData.optical_used_bins}</StyledTCellBody>
      <StyledTCellBody>{rowData.use_bins}</StyledTCellBody>
      <StyledTCellBody>{`${![undefined, 'undefined', null, 'null', ''].includes(rowData.pharmacy_utilization) ? rowData.pharmacy_utilization : 0}%`}</StyledTCellBody>
      <StyledTCellBody>{`${![undefined, 'undefined', null, 'null', ''].includes(rowData.optical_utilization) ? rowData.optical_utilization : 0}%`}</StyledTCellBody>
      <StyledTCellBody>{`${![undefined, 'undefined', null, 'null', ''].includes(rowData.box_utilization) ? rowData.box_utilization : 0}%`}</StyledTCellBody>
      <StyledTCellBody>
        {convertToTimeZone(rowData.utilization_date) || ''}
      </StyledTCellBody>
    </StyledTRowBody>
  );
}



// WEBPACK FOOTER //
// ./src/components/reports/kiosk-box-utilization/table-view/BoxReportTRow.jsx